import Menu from "@/parent-components/NavBar/Menu";

const NavBarFooter = ({ data, flag }) => {
  return (
    <nav
      className="navbar navbar-expand-lg navbar-light py-4 footer-nav"
      data-testid="navbar-container-id"
    >
      <Menu menuData={data} sublink={flag} />
    </nav>
  );
};

export default NavBarFooter;
